import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Layout from "layouts/Layout";
import { LinkEnhancer } from "@commerce-core/react-components";

ReactDOM.createRoot(document.getElementById("react-app")!).render(
  <React.StrictMode>
    <LinkEnhancer>
      <Layout />
    </LinkEnhancer>
  </React.StrictMode>
);
